<div class="flex items-start md:items-center md:justify-center min-h-full">
  <div class="p-4 w-full max-w-full md:max-w-3xl bg-white mx-auto">
    <div class="relative flex justify-center mt-6">
      <img [src]="imageUrl || 'assets/images/profile.png'" [alt]="name"
        class="w-24 h-24 rounded-full object-cover border-4 border-white shadow-md mx-auto"
        (error)="onImageError($event)" />

      <div class="absolute top-0 right-0 flex ">

        <button (click)="copyLink()" class="p-2" title="Copiar link">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-metro-blue-secondary" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
            <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
          </svg>

        </button>

        <!-- Compartir -->
        <button (click)="shareLink()" class="p-2" title="Compartir">
          <svg class="h-5 w-5 text-metro-blue-secondary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 9h-1a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2h-1" />
            <path d="M12 14v-11" />
            <path d="M9 6l3 -3l3 3" />
          </svg>

        </button>

      </div>
    </div>


    <div class="text-center mt-2 space-y-1">
      <h2 class="text-lg font-semibold text-metro-black">{{ name }}</h2>
      <p class="text-sm text-metro-blue">{{ role }}</p>
      <p class="text-xs text-metro-blue">{{"::ConnectedFrom" | abpLocalization}} {{ connectedSince }}</p>
    </div>


    @if(primaryButtonLabel){
    <div class="flex justify-center mt-2">
      <app-metro-button variant="primary" class="w-full md:w-auto" (click)="onPrimaryClick()"
        [text]='"::ViewCatalog" | abpLocalization'>
      </app-metro-button>
    </div>}

    <!-- Descripción -->
    <div class="py-4 text-gray-700 text-sm">
      <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
      <p class="mb-2" [innerHTML]="description"></p>
    </div>
    @if(secondaryButtonLabel){

    <div class="flex justify-end mb-6">
      <app-metro-button variant="secondary" (click)="onSecondaryClick()" [text]='"::Contact" | abpLocalization'>
      </app-metro-button>
    </div>
    }
  </div>
</div>